import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Substitutions extends Endpoint {
  async fromFilter(filterId) {
    const url = new URL(`/api/substitutions/filter/${filterId}`, API_URL)

    return this.request(url)
  }

  async fromApplication(applicationId) {
    const url = new URL(`/api/substitutions/application/${applicationId}`, API_URL)
    return this.request(url)
  }

  async fromContact(contactId) {
    const url = new URL(`/api/substitutions/contact/${contactId}`, API_URL)
    return this.request(url)
  }
}
